import {
  BoardMachinesStates,
  PhysicalDetailsState,
} from "../../../../../reducers/uploadedBoard";

export enum PhysicalDetailsRefreshAction {
  REFRESH = "refresh",
  DEBOUNCED_REFRESH = "debounced_refresh",
  UPDATE_STATE_ONLY = "update_state_only",
}

function physicalDetailsWereUpdated(
  nextStates: BoardMachinesStates,
  states: BoardMachinesStates,
): boolean {
  if (nextStates.physical_details_datetime_updated === null) {
    return false;
  }
  if (states.physical_details_datetime_updated === null) {
    // First time this board finished processing
    return true;
  }
  return (
    states.physical_details_datetime_updated <
    nextStates.physical_details_datetime_updated
  );
}

function processingJustFinished(
  nextStates: BoardMachinesStates,
  states: BoardMachinesStates,
): boolean {
  return (
    nextStates.physical_details_state === PhysicalDetailsState.PROCESSED &&
    states.physical_details_state !== PhysicalDetailsState.PROCESSED
  );
}

/**
 * Decide how to react to a physical details state message.
 *
 * The board in the store only has check results and physical details from
 * its last fetch, so any message that means processing produced new details
 * must trigger a fetch. Only flipping the state in the store is safe when the
 * details themselves cannot have changed.
 */
export function getPhysicalDetailsRefreshAction(
  nextStates: BoardMachinesStates,
  states: BoardMachinesStates,
): PhysicalDetailsRefreshAction {
  if (
    physicalDetailsWereUpdated(nextStates, states) ||
    processingJustFinished(nextStates, states)
  ) {
    return PhysicalDetailsRefreshAction.REFRESH;
  }
  if (nextStates.physical_details_state === PhysicalDetailsState.PROCESSING) {
    // If it's still processing, just load less often
    return PhysicalDetailsRefreshAction.DEBOUNCED_REFRESH;
  }
  return PhysicalDetailsRefreshAction.UPDATE_STATE_ONLY;
}
